import { store } from '@/store';
import getDashedTitle from '@/utilities/getDashedTitle';
import router from '@/router';
import constants from '@/utilities/constants';
import { translate } from '@/utilities';

export const createNewPageAndUpdateRoute = async (pageParam, noContent = false) => {
  // set page creating in progress flag
  store.dispatch('pageCreating', true);
  const currentProjectId = store.getters.getCurrentProjectId;
  // create page with existing title and content
  const newpage = {
    ...pageParam,
    project_id: currentProjectId,
    user_id: store.getters.getUserId,
  };
  return store.dispatch('createNewPage', { page: newpage, noContent }).then(async ({ page }) => {
    store.dispatch('setCurrentPageID', page.id);
    store.dispatch('updatePageMeta', page);

    store.dispatch('localRemovePageInTree', {
      projectId: page.project_id,
      pageId: store.getters.sidebarDraftPage.id,
    });

    store.dispatch('addPageToProjectPages', {
      pageId: page.id,
      projectId: currentProjectId,
    });

    store.dispatch('localAddPageInPageTree', {
      projectId: currentProjectId,
      pageId: page.id,
    });

    store.dispatch('localAddPageInProject', {
      projectId: page.project_id,
      page,
    });

    if (store.getters.getParentPageIdForAdd !== 'root') {
      store.dispatch('addUiNotification', {
        message: translate('subpageCreated'),
        icon: 'page',
        status: constants.uiNotificationStatuses.success,
      });
    }

    await updatePageRoute(page);

    store.dispatch('pageCreating', false);
    store.dispatch('setLastSidebarItemAdded', page.id);
    store.dispatch('setParentPageIdForAdd', 'root');

    const editorOldId = 'editor-page-newpage';
    const teamId = store.getters.getTeamID;
    const newId = `${teamId}-editor-page-${page.id}`;
    store.dispatch('updateEditorId', { oldId: editorOldId, newId, resourceId: page.id });

    return page;
  });
};

export const updatePageRoute = async (page) => {
  store.dispatch('setSidebarPageDraft', {});
  const currentRoute = store.getters.getCurrentRoute;

  const baseUrl = `/${store.getters.getTeamSlug}/page-${page.id}`;
  let route = baseUrl;
  if (page.title) {
    const dashedTitle = `-${getDashedTitle(page.title)}`;
    route = `${baseUrl}${dashedTitle}`;
  }
  if (route !== currentRoute.path) {
    await router.replace(route);
  }
};
